import Mustache from 'mustache';
import {memoize} from '@servicenow/ui-internal';

const mustacheTokens = ['#', '^', '>', '&', 'name'];

function TemplateVarsMissingException(query, expectedTemplateVars) {
	this.name = 'TemplateVarsMissingException';
	this.message = 'template_vars missing for GraphQL query';
	this.query = query;
	this.expectedTemplateVars = expectedTemplateVars;
	this.stack = new Error(this.message).stack;
}

TemplateVarsMissingException.prototype = new Error();

/**
 * Match template vars up with query template, throw if missing any vars
 *
 * @private
 * @param queryStr
 * @param templateParts
 * @param templateVars
 * @throws TemplateVarsMissingException
 * @return {void}
 */
function assertValidTemplateVars(queryStr, templateParts, templateVars) {
	const {length: templatePartsLength} = templateParts;
	for (let i = 0; i < templatePartsLength; i++) {
		if (!templateVars[templateParts[i]])
			throw new TemplateVarsMissingException(queryStr, templateParts);
	}
}

/**
 * Parse template variable tokens from query
 *
 * @private
 * @param queryStr
 * @return [Array<String>] tokens
 */
function getTokens(queryStr) {
	const parts = Mustache.parse(queryStr);
	const tokens = [];
	const {length: partsLength} = parts;

	for (let i = 0; i < partsLength; i++) {
		const part = parts[i];
		if (mustacheTokens.includes(part[0])) tokens.push(part[1]);
	}

	return tokens;
}

const memGetTokens = memoize(getTokens, {profileName: 'getTokens'});

export default function replaceQueryTemplateVariables(queryStr = '', templateVars = {}) {
	const tokens = memGetTokens(queryStr);
	assertValidTemplateVars(queryStr, tokens, templateVars);
	return Mustache.render(queryStr, templateVars);
}
